const QUERY_URL = process.env.API_URL + '/query/';

const getQueries = (context, tags) => {
  const ids = tags.length === 0 ? undefined : tags.join(',');
  return context.$http.get(QUERY_URL, { params: { tags: ids } });
};

const createQuery = (context, query) => {
  return context.$http.post(QUERY_URL, query);
};

const updateQuery = (context, query) => {
  return context.$http.put(QUERY_URL, query);
};

const deleteQuery = (context, id) => {
  return context.$http.delete(QUERY_URL, {params: {id: id}});
};

const getPermissionsByUser = (context, queryId) => {
  return context.$http.get(QUERY_URL + queryId + '/permissions/users');
};

const getPermissionsByGroup = (context, queryId) => {
  return context.$http.get(QUERY_URL + queryId + '/permissions/groups');
};

const addPermission = (context, permissionType, queryId, userOrGroup, userOrGroupId) => {
  return context.$http.put(QUERY_URL + queryId + '/permission/' + permissionType + '/' + userOrGroup + '/' + userOrGroupId);
};

const deletePermission = (context, permissionType, queryId, userOrGroup, userOrGroupId) => {
  return context.$http.delete(QUERY_URL + queryId + '/permission/' + permissionType + '/' + userOrGroup + '/' + userOrGroupId);
};

export default {
  getQueries,
  createQuery,
  updateQuery,
  deleteQuery,
  getPermissionsByUser,
  getPermissionsByGroup,
  addPermission,
  deletePermission
};



// WEBPACK FOOTER //
// ./src/api/query/queryHttp.js